import ChooseCertificateAction from './ChooseCertificateAction';
import type { ChooseCertificateActionProps } from './types';

export default ChooseCertificateAction;
export type { ChooseCertificateActionProps };
